import type { PeriodTimeline } from "../api/types";
import { cn } from "../lib/cn";
import { activePrecipTypes } from "../lib/timelineTint";

import PrecipTracksRow from "./dayCardTimeline/PrecipTracksRow";
import ThunderDotsRow from "./dayCardTimeline/ThunderDotsRow";
import TimelineAxis from "./dayCardTimeline/TimelineAxis";
import WindSparklineRow from "./dayCardTimeline/WindSparklineRow";

interface Props {
  timeline: PeriodTimeline;
  className?: string;
}

export default function DayCardTimeline({ timeline, className }: Props) {
  const types = activePrecipTypes(timeline.hours);

  return (
    <div
      aria-hidden
      className={cn("relative flex flex-col", className)}
      data-layout={timeline.layout}
    >
      <ThunderDotsRow hours={timeline.hours} />
      <PrecipTracksRow hours={timeline.hours} layout={timeline.layout} types={types} />
      <TimelineAxis labels={["6a", "10a", "2p", "6p", "10p", "12a"]} className="mt-[6px]" />
      <WindSparklineRow hours={timeline.hours} className="mt-[6px]" />
    </div>
  );
}
